import axios from 'axios'
import store from '@/store'
import guid from '@/library/guid'
import config from '@/config'
import api from './api/'
import router from '@/router'
import {localeProperties} from '@/library/locale/i18n'

export default {
  call,
  attachParams,
  // refreshTokenPromise,
  refreshToken,
  helpers: api.helpers
}

var autoRefreshToken = config.app.autoconf.TRANSACTION_SERVER_API_AUTO_REFRESH_TOKEN
var refreshTokenInProgress = false
var refreshTokenPromise = null
let authListenerInitiated = false
let refFunction = null
const capacitorIsEnabled = config.app.autoconf.CAPACITOR_ENABLED
const authServerEnabled = config.app.autoconf.AUTH_SERVER_ENABLED

guid.init()

function call (serviceName, methodName, params) {
  var axiosConfig = api.helpers.createAxiosConfig(serviceName, methodName)

  if (['checkticket', 'wishbetclient'].includes(serviceName)) {
    let token = api.helpers.getWishAuthToken()
    if (token) attachWishBetAuthToken(axiosConfig, token)
  }
  attachAuthToken(axiosConfig)
  attachGUID(axiosConfig)
  attachDeviceInfo(axiosConfig)
  overrideRequest(serviceName, methodName, axiosConfig)
  attachParams(axiosConfig, params)
  attachAuthServerToken(axiosConfig)

  if (axiosConfig.refreshToken) {
    return refreshToken()
  }

  if (refreshTokenInProgress) {
    return callAfterRefreshToken(axiosConfig)
  }
  return sendRequest(axiosConfig, methodName)
}

function overrideRequest (serviceName, methodName, axiosConfig) {
  if (api.services[serviceName]) api.services[serviceName].overrideRequest(axiosConfig)
  if (api.services[serviceName] && api.services[serviceName][methodName]) api.services[serviceName][methodName].overrideRequest(axiosConfig)

  // override with configuration from static app-conf.js
  var staticConfig = config.app.autoconf.TRANSACTION_SERVER_API_CALL_OVERRIDES

  if (staticConfig[serviceName] && staticConfig[serviceName][methodName]) {
    Object.assign(axiosConfig, staticConfig[serviceName][methodName])
  }
}

function attachParams (axiosConfig, params) {
  if (params && axiosConfig && axiosConfig.params && axiosConfig.data) {
    params.language = localStorage.userLocale && localeProperties.isLocaleSupported(localStorage.userLocale) ? localStorage.userLocale.toUpperCase() : localeProperties.getDefaultLocale
    switch (axiosConfig.method) {
      case 'get':
        Object.assign(axiosConfig.params, params)
        break
      case 'post':
        if (axiosConfig.uploadFile) {
          Object.assign(axiosConfig.headers, {'Content-Type': 'multipart/form-data'})
          if (capacitorIsEnabled) {
            Object.assign(axiosConfig.headers, {'IGT-document-upload': 'yes'})
          }
          axiosConfig.data = params
        } else {
          Object.assign(axiosConfig.data, params)
        }
        break
    }
  }
}

function attachAuthToken (axiosConfig) {
  Object.assign(axiosConfig.headers, api.helpers.createAuthorizationHeader(api.helpers.getToken('access')))
}

function attachWishBetAuthToken (axiosConfig, token) {
  Object.assign(axiosConfig.headers, {Authorization: token})
}

function attachGUID (axiosConfig) {
  Object.assign(axiosConfig.headers, api.helpers.createGUIDHeader())
}

function attachDeviceInfo (axiosConfig) {
  Object.assign(axiosConfig.headers, api.helpers.createDeviceInfoHeader())
}

function attachAuthServerToken (axiosConfig) {
  Object.assign(axiosConfig.headers, api.helpers.createAuthorizationServerHeader(api.helpers.getAuthServerToken()))
}

function revisedRandId () {
  let randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26))
  return randLetter + Date.now()
}

function sendRequest (axiosConfig) {
  let dynamicId = revisedRandId()
  let date = Date.now()
  axios.defaults.headers.common['Accept-Language'] = localStorage.userLocale && localeProperties.isLocaleSupported(localStorage.userLocale) ? localStorage.userLocale.toUpperCase() : localeProperties.getDefaultLocale
  return axios(axiosConfig).then((response) => {
    // store tokens from response if available
    api.helpers.storeTokens(response)
    let data = api.helpers.modifyResponse(response)
    setDebuggerLogs({'date': date, 'type': 'api', 'request': axiosConfig, 'dynamicId': dynamicId, 'response': response})
    return Promise.resolve(data)
  }).catch((err) => {
    if ((window.ctsautoconf.MOBILE_LS && !axiosConfig.url.includes('getcurrentutcdatetime')) && (err && err.response && err.response.data) && err.response.data.ExceptionType === 'MobileAppVersionIsNotAllowedException') {
      api.helpers.appNotAllowed()
    }
    var status = err.response ? err.response.status : ''
    var showUnknownErrorModal = window.ctsautoconf.SHOW_UNKNOWN_ERROR_MODAL

    switch (status) {
      case 401:
        if (refreshTokenInProgress) {
          // if refresh token in progres wait for it and make same request again
          return callAfterRefreshToken(axiosConfig)
        } else {
          if (api.helpers.isLoggedIn() && autoRefreshToken) {
            refreshToken()
            return callAfterRefreshToken(axiosConfig)
          }
          if (store.getters['isLoggedIn']) {
            store.dispatch('overlayState/deactivateMessageDialog')
            store.dispatch('overlayState/deactivateGeolocationDialog')
            store.dispatch('overlayState/deactivateSessionDialog')
            store.commit('setSessionExpired', true)
            let type = '401'
            router.push({name: 'logout', params: {type}})
          }
          handleErrorForMobileDebugger(status, axiosConfig, err, date, dynamicId)
          return Promise.reject(api.helpers.modifyErrorResponse(err, axiosConfig))
        }
      case 403:
        // console.log('403 - auth server responded', axiosConfig)
        return Promise.reject(api.helpers.modifyErrorResponse(err, axiosConfig))
      case 409:
        // console.log('409 - conflict', axiosConfig)
        store.commit('overlayState/setMessageDialogMsg', {reason: 'conflict', persistent: true, fullscreen: false, err: err && err.response && err.response.data})
        store.dispatch('overlayState/activateMessageDialog')
        return Promise.reject(api.helpers.modifyErrorResponse(err, axiosConfig))
      case 486:
        // console.log('486 - auth server responded - REQUEST DATA', axiosConfig)
        // console.log('486 - auth server responded - MODIFIED', api.helpers.modifyErrorResponse(err, axiosConfig))
        console.log('486 - auth server responded - RAW', err.response)
        // open iframe given from Auth server.
        if (err.response && err.response.data && err.response.data.redirectUrl) store.dispatch('overlayState/activateAuthDialog', api.helpers.modifyErrorResponse(err, axiosConfig))
        // create a new Promise to hold resolving in the component/file who initiated the intercepted request.
        return new Promise((resolve, reject) => {
          if (!authListenerInitiated) {
            authListenerInitiated = true
            let authActionName = (err.response && err.response.data && err.response.data.actionName) || false
            refFunction = function (event) {
              if (!event.data) return
              let data = event.data
              // the name of the event declared from both sides
              if (data.sender && data.sender === 'authServer') {
                if (event.data && event.data.pswsAction && event.data.pswsAction === 'closeTimeout') return // this will be handled in auth dialog
                // console.log('%c --- AUTH POST MESSAGE RESPONDED WITH ---', 'border:1px solid #25BC70; color: #25BC70')
                // console.log(data)
                // console.log('%c -----', 'border:1px solid #25BC70; color: #25BC70')
                let xAuthToken = data.xAuthToken || false
                let pswsAction = data.pswsAction || false
                let endpoint = data.endpoint || false
                let isMultiPurposeToken = data.isMultiPurposeToken || false
                let actionName = data.actionName || false
                let loginResult = data.loginResult || false
                // store auth server token pair
                if (xAuthToken && actionName) {
                  api.helpers.storeAuthServerToken({xAuthToken, actionName, endpoint, isMultiPurposeToken})
                }
                // close iframe and reject promise for the actionName defined in the method to keep UI part in shape. Otherwise, do nothing.
                if (pswsAction && pswsAction.toLowerCase() === 'close') {
                  // console.log('AUTH on close reject promise', authActionName)
                  store.dispatch('overlayState/activateAuthDialog', false)
                  store.commit('setFormSubmitSppiner', false)
                  store.dispatch('getCustomerContext')
                  if (authActionName && api.helpers.returnAuthServerResolveRejectForSpecificMethod(authActionName)) {
                    reject(new Error('authOperationCancelled'))
                  }
                  window.removeEventListener('message', refFunction, false)
                  refFunction = null
                  authListenerInitiated = false
                }
                attachAuthServerToken(axiosConfig)
                // close iframe and repeat previous action / intercepted request
                if (xAuthToken && pswsAction && pswsAction.toLowerCase() === 'closeandrepeatpreviousaction') {
                  // console.log('AUTH try to resolve from POST MESSAGE')
                  setTimeout(() => {
                    store.dispatch('overlayState/activateAuthDialog', false)
                  }, 1500)
                  setTimeout(() => {
                    sendRequest(axiosConfig).then(response => {
                      // console.log('AUTH response from retry AXIOS config', response)
                      resolve(response)
                      window.removeEventListener('message', refFunction, false)
                      refFunction = null
                      authListenerInitiated = false
                    }).catch(err => {
                      // console.log('AUTH CATCH from AXIOS', err)
                      window.removeEventListener('message', refFunction, false)
                      refFunction = null
                      authListenerInitiated = false
                      reject(err)
                    })
                  }, 2000)
                }
                // close iframe and refresh customer context // Except Login flow
                if ((pswsAction && pswsAction.toLowerCase() === 'closeandrefreshcustomercontext') && (!actionName || actionName.toLowerCase() !== 'login')) {
                  setTimeout(() => {
                    store.dispatch('overlayState/activateAuthDialog', false)
                  }, 1500)
                  if (actionName && (actionName.toLowerCase() === 'password-set' || actionName.toLowerCase() === 'account-recovery') && loginResult) { // on account recovery, auth server will login user and provide login data to client side.
                    let data = {
                      'loginResult': loginResult
                    }
                    store.dispatch('loginResponse', {'result': data})
                    if (actionName.toLowerCase() === 'password-set') {
                      setTimeout(() => {
                        router.push({
                          name: 'settings',
                          query: {
                            'password-change': ''
                          }
                        }).catch(err => { console.log(err) })
                      }, 1000)
                      store.dispatch('overlayState/activateChangePasswordDialog')
                    }
                  }
                  if ((actionName && actionName.toLowerCase() !== 'account-recovery') || !actionName) store.dispatch('getCustomerContext')
                  window.removeEventListener('message', refFunction, false)
                  refFunction = null
                  authListenerInitiated = false
                  return false
                }
                // close iframe and refresh customer context // On login
                if ((pswsAction && pswsAction.toLowerCase() === 'closeandrefreshcustomercontext') && (actionName.toLowerCase() === 'login' && loginResult.sessionTokens)) {
                  store.dispatch('loginResponse', {'result': data})
                  setTimeout(() => {
                    store.dispatch('overlayState/activateAuthDialog', false)
                  }, 1500)
                  window.removeEventListener('message', refFunction, false)
                  refFunction = null
                  authListenerInitiated = false
                  return false
                }
              }
            }
            addEventListener('message', refFunction, false)
          }
        })
      case 503:
        if (window.ctsautoconf.MOBILE_LS) {
          handleErrorForMobileDebugger(status, axiosConfig, err, date, dynamicId)
          api.helpers.checkMaintenance()
        }
        break
      case 500:
      case 501:
      case 502:
      case 504:
      case 505:
      case 506:
      case 507:
      case 508:
      case 509:
      case 510:
      case 511:
        store.commit('setInternalError', err.response.data)
        handleErrorForMobileDebugger(status, axiosConfig, err, date, dynamicId)
        return Promise.reject(api.helpers.modifyErrorResponse(err, axiosConfig))
      default:
        if (!status && err && err.request && showUnknownErrorModal) {
          // CIP ONC44 - Closing AUTH dialog as the iframe becomes unresponsive due to CORS errors and removing state from AuthDialog so footer would remain visible
          if (authServerEnabled) {
            store.dispatch('overlayState/activateAuthDialog', false)
            store.commit('overlayState/setAuthDialogState', false)
          }
        }
        handleErrorForMobileDebugger(status, axiosConfig, err, date, dynamicId)
        return Promise.reject(api.helpers.modifyErrorResponse(err, axiosConfig))
    }
  })
}

function refreshToken () {
  let refreshAxiosConfig = api.helpers.createAxiosConfig('auth', 'refreshtoken')

  refreshAxiosConfig.method = 'post'

  attachParams(refreshAxiosConfig, {
    client_id: 'web',
    client_secret: '',
    refresh_token: api.helpers.getToken('refresh')
  })

  refreshTokenPromise = axios(refreshAxiosConfig).then((response) => {
    // update session details with new access and refresh token
    api.helpers.storeTokens(response)
    return api.helpers.modifyResponse(response)
  }).catch((err) => {
    store.dispatch('logout', true)
    return Promise.reject(api.helpers.modifyErrorResponse(err, refreshAxiosConfig))
  }).finally(() => {
    refreshTokenInProgress = false
  })

  refreshTokenInProgress = true

  return refreshTokenPromise
}

function callAfterRefreshToken (axiosConfig) {
  return refreshTokenPromise.then((response) => {
    attachAuthToken(axiosConfig)
    return sendRequest(axiosConfig)
  }).catch(() => {
    return sendRequest(axiosConfig)
  })
}

function handleErrorForMobileDebugger (status, axiosConfig, err, date, dynamicId) {
  try {
    if (status && (window.ctsautoconf.MOBILE_LS && config.app.autoconf.MOBILE_DEBUGGER_DIALOG && config.app.autoconf.MOBILE_DEBUGGER_DIALOG.ENABLED)) {
      err.response.data['status'] = err.response.status
      setDebuggerLogs({
        'date': date,
        'type': 'api',
        'dynamicId': dynamicId,
        'request': axiosConfig,
        'response': api.helpers.modifyErrorResponse(err, axiosConfig)
      })
    }
  } catch (e) {
    console.log('handleErrorForMobileDebugger error:', e)
  }
}

function setDebuggerLogs (data) {
  if (window.ctsautoconf.MOBILE_LS && config.app.autoconf.MOBILE_DEBUGGER_DIALOG && config.app.autoconf.MOBILE_DEBUGGER_DIALOG.ENABLED) {
    store.commit('setNetworkLogOutput', {'date': data.date, 'type': 'api', 'request': data.request, 'dynamicId': data.dynamicId, 'response': data.response})
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api.js